<ng-container *ngIf="!selected && !creatingTask">
  <div class="sidebar-header" fxLayout fxLayoutAlign="space-between center">
    <h3>Tasks</h3>

    <sbnb-close (click)="closeMenu()"></sbnb-close>
  </div>

  <div class="tasks">
    <div *ngIf="!tasks || tasks.length === 0">
      <sbnb-no-items
        text="No tasks on this day"
        subtext="You haven’t created any tasks on this day yet."></sbnb-no-items>
    </div>

    <div
      *ngFor="let task of tasks"
      class="task"
      [class.task-checkInOut]="task.task_type === 4 || task.task_type === 2"
      [class.task-maintenance]="task.task_type === 5"
      fxLayout="column"
      fxLayoutGap="4px"
      (click)="selectedTask(task)">
      <strong>{{ task.task_rule?.name ? task.task_rule.name : task.task_type_string }}</strong>
      <div>
        {{ task.teammate ? task.teammate.name : 'Unassigned' }} from {{ task.start_date_label }} to
        {{ task.end_date_label }}
      </div>
      <sbnb-cs-debug-item
        (click)="$event.stopPropagation()"
        label="uuid"
        [coreNovaLink]="'/resources/tasks?tasks_page=1&tasks_search=' + task.uuid"
        [linkLabel]="'Nova'"
        [value]="task.uuid"></sbnb-cs-debug-item>
    </div>

    <sbnb-button
      *ngIf="perms$.hasAccessTo(Features.PERM_TASKS_UPDATE_ALL) | async"
      style="margin-top: 8px; display: block"
      [fullWidth]="true"
      label="+ New"
      size="mini"
      type="secondary"
      (click)="creatingTask = true"></sbnb-button>
  </div>
</ng-container>

<ng-container *ngIf="selected">
  <div class="sidebar-header task-detail">
    <div (click)="selected = null" class="clickable back">
      <img src="/assets/iconography/back.svg" alt="Back" />
    </div>

    <sbnb-menu-task-assign
      [task]="selected"
      [propertyId]="selected.property.id"
      (updatedTask)="handleTaskUpdated($event)"
      (taskDeleted)="handleTaskDeleted($event)"
      (closeMenu)="closeMenu()"></sbnb-menu-task-assign>
  </div>
</ng-container>

<ng-container *ngIf="creatingTask">
  <div class="sidebar-header task-detail">
    <div (click)="creatingTask = false" class="clickable back">
      <img src="/assets/iconography/back.svg" alt="Back" />
    </div>

    <sbnb-menu-task-assign
      [mode]="'new'"
      [newDate]="date"
      [propertyId]="property?.id"
      (createdTask)="handleTaskCreated($event)"
      (closeMenu)="closeMenu()"></sbnb-menu-task-assign>
  </div>
</ng-container>
